import React from "react";
import { Info, CheckCircle2, AlertTriangle, XCircle } from "lucide-react";
import { cn } from "@/lib/utils";

const VARIANTS = {
  info: {
    wrapperClass: "border-blue-300 bg-blue-50 dark:bg-blue-950/30 dark:border-blue-900",
    iconClass: "text-blue-700 dark:text-blue-400",
    titleClass: "text-blue-900 dark:text-blue-300",
    bodyClass: "text-blue-800/90 dark:text-blue-200/90",
    Icon: Info,
  },
  warning: {
    wrapperClass: "border-amber-300 bg-amber-50 dark:bg-amber-950/30 dark:border-amber-900",
    iconClass: "text-amber-700 dark:text-amber-400",
    titleClass: "text-amber-900 dark:text-amber-300",
    bodyClass: "text-amber-800/90 dark:text-amber-200/90",
    Icon: Info,
  },
  success: {
    wrapperClass: "border-emerald-300 bg-emerald-50 dark:bg-emerald-950/30 dark:border-emerald-900",
    iconClass: "text-emerald-700 dark:text-emerald-400",
    titleClass: "text-emerald-900 dark:text-emerald-300",
    bodyClass: "text-emerald-800/90 dark:text-emerald-200/90",
    Icon: CheckCircle2,
  },
  error: {
    wrapperClass: "border-rose-300 bg-rose-50 dark:bg-rose-950/30 dark:border-rose-900",
    iconClass: "text-rose-700 dark:text-rose-400",
    titleClass: "text-rose-900 dark:text-rose-300",
    bodyClass: "text-rose-800/90 dark:text-rose-200/90",
    Icon: XCircle,
  },
};

export default function StatusBanner({ variant = "info", title, children, className }) {
  const v = VARIANTS[variant];
  const { Icon } = v;
  return (
    <div
      role="status"
      className={cn("rounded-md border p-4 text-sm flex gap-3", v.wrapperClass, className)}
    >
      <Icon className={cn("h-5 w-5 shrink-0 mt-0.5", v.iconClass)} aria-hidden="true" />
      <div>
        <div className={cn("font-semibold", v.titleClass)}>{title}</div>
        {children && (
          <div className={cn("mt-1 leading-relaxed", v.bodyClass)}>{children}</div>
        )}
      </div>
    </div>
  );
}
